import React, { useState, useEffect, useMemo } from 'react';
import './assets/createNodeClass.css'
import LeftChevron from './assets/chevron-left.svg';
import { Button, DatePicker, Form, Input, Radio, Select } from 'antd';



function CreateNodeClass(props) {

	const [form] = Form.useForm();

	const BASE_URL = process.env.REACT_APP_BASE_URL;

	const { TextArea } = Input;

	const [category, setCategory] = useState('')

	const [cloudProvider, setCloudProvider] = useState('')

	const [nodeClass, setNodeClass] = useState('')

	const [disableSave, setDisableSave] = useState(true)

	const options=[
        {
          value: 'tk-prod',
          label: 'tk-prod'
        }]

  useEffect(() => {
  	if( cloudProvider != "") {
  		setDisableSave(false)
  	} else {
  		setDisableSave(true)
  	}

  }, [cloudProvider, nodeClass])

	const handleChange = (value: string | string[]) => {
  		console.log(`Selected: ${value}`);
  		setCategory(value)
	};

	function handleCloudProvider(e) {
		console.log(e.target.value)
		setCloudProvider(e.target.value)
	}

	function handleNodeClass(e) {
		setNodeClass(e.target.value)
	}

	function handleClose() {
		props.handleClose()
	}

	function handleCreateNode() {
		console.log("Hello")
		setDisableSave(true)
		var apikey = localStorage.getItem('db_portal_app_apikey')
   	var oauth_token = localStorage.getItem('db_portal_oauth_token')
		fetch( BASE_URL + '/v1/node' ,{
	    			method : 'POST',
	    			headers : {
	    				'Accept':'application/json',
	        			'Content-Type':'application/json',
	    				'x-api-key' : apikey,
	    				'oauth-token' : oauth_token
	    			},
	    			body : JSON.stringify({ 
	            "cloud_provider" : cloudProvider,
	            "node_class" : nodeClass
	        })
	    	})
	    	.then(res =>
	    		res.json())
	    	.then((data) => {
	    			props.handleSuccess()
	    	})
	    	.catch(console.log)
	}

	return (
			<div className="App-NodeClass-create-node-container">
				<div className="App-NodeClass-create-node-modal-content">
					<div className="App-NodeClass-create-node-modal-header">
		 				<div className="App-NodeClass-create-node-modal-back-icon" onClick={handleClose}>
		 					<img src={LeftChevron} />
		 				</div>
 						<div className="App-NodeClass-create-node-modal-header-content"> Add Node Class </div>
					</div>
					<div className="App-NodeClass-create-node-modal-body">
						<div className="App-NodeClass-create-node-form-container">
						<Form
      						form={form}
      						layout="vertical"
      					>
      						<Form.Item label="Node Class">
        						<Input placeholder="Type Here" value={nodeClass} onChange={handleNodeClass}/>
      						</Form.Item>
      						<Form.Item label="Cloud Provider">
        						<Input placeholder="Type Here" value={cloudProvider} onChange={handleCloudProvider}/>
      						</Form.Item>
      					</Form>
      					</div>
					</div>
					<div className="App-NodeClass-create-node-modal-footer">
						<div className="App-NodeClass-create-node-footer-button-container">
							<Button 
	              				onClick = {() => handleClose()}
	              			>
	              				Cancel
	            			</Button>
	            			<Button
	            				type='primary'
	              				onClick = {() => handleCreateNode()}
	              				disabled = {disableSave}
	              			>
	              				Save
	            			</Button>
            			</div>
					</div>
				</div>
			</div>
		)

}

export default CreateNodeClass
